export interface CommodityUnloadTimesEffectiveResource {
    id?: number;
    commodityCode : string;
    facilityCode : string;
    timePerUnit: string;
    createdDate: Date;
    createdBy: string;
    updatedDate: Date;
    updatedBy: string;
    isOverRidden: boolean
}

export interface GetCommodityUnloadTimesEffectiveRequest{
    commodityCode : string;
    facilityCode: string;
    overriddenOnly: boolean
}

export interface CreateCommodityUnloadTimeOverrideRequest {
    commodityCode : string;
    facilityCode: string;
    timePerUnit: string;
    isActive: boolean;
}

export class EditCommodityUnloadTimeOverideModel {
    commodityCode : string;
    facilityCode: string;
    timePerUnit: string;
    visible: boolean = true;
    saving: boolean = false;
  
    toCreateRequest(): CreateCommodityUnloadTimeOverrideRequest {
      return { commodityCode: this.commodityCode, facilityCode: this.facilityCode, timePerUnit: this.timePerUnit, isActive: true };
    }
  }